import React from 'react';
import { Dialog, IconButton, useMediaQuery } from "@mui/material";
import PaySystemList from './PaySystemList';
import { styled, useTheme } from "@mui/material/styles";
import PSIcon from '../../components/PSIcon';
import { getText } from "../../libs/utils";


const ArrowButton = styled(IconButton)(() => ({
  position: 'relative',
  padding: '5px 25px 5px 5px',
  margin: '0 18px 0 0',
  "&::after": {
    content: "''",
    width: '12px',
    height: '6px',
    position: 'absolute',
    top: '50%',
    right: '0px',
    transform: 'translate(0, -50%)',
    background: 'url("/images/arrow-bottom.svg") center no-repeat',
    backgroundSize: 'contain',
    transition: 'transform 0.2s',
  },
  "&.active::after": {
    transform: 'translate(0, -50%) rotate(180deg)',
  }
}))

const ChoosePsMobile = ({ title, setOpenDialog, openDialog, paySystems, system, setSystem, currency, setCurrency }) => {
  const theme = useTheme();
  let isXS = useMediaQuery(theme.breakpoints.only('xs'));
  let isSM = useMediaQuery(theme.breakpoints.only('sm'));

  return (
    <>
      <ArrowButton
        onClick={() => setOpenDialog(!openDialog)}
        className={openDialog && 'active'}
      >
        <PSIcon
          name={system.className}
          network={currency.network}
          height={40}
          width={40}
          margin={0}
        />
      </ArrowButton>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="lg"
        classes={{
          paper: 'systems-list'
        }}
      >
        <PaySystemList
          title={title}
          list={paySystems}
          onClose={() => setOpenDialog(false)}
          activeSystem={system}
          setSystem={setSystem}
          setCurrency={setCurrency}
          grid={isSM ? 4 : isXS ? 2 : 5}
        />
      </Dialog>
    </>
  )
}

export default ChoosePsMobile